import type { App } from 'vue';
import VueGtag from 'vue-gtag';
import type { RouteLocation, Router } from 'vue-router';
import PageTitles from '~/config/PageTitles';

function installGTag(app: App, router: Router) {
  app.use(VueGtag, {
    includes: [
      { id: 'UA-118650281-1' },
    ],
    config: {
      id: 'G-NYFWYHHSPY',
    },
    pageTrackerTemplate: (to?: RouteLocation) => {
      if (!to) {
        return {
          page_path: window.location.pathname,
          page_location: window.location.href,
        };
      }
      const pageName: string = to.name as string;
      const pageTitle = (PageTitles as Record<string, string>)[pageName];
      return {
        page_title: pageTitle,
        page_path: to.path,
        page_location: to.fullPath,
      };
    },
  }, router);
}

export default installGTag;
